import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetUsage, apiSaveUsage, apiUpdateUsage } from "../../../api/ApiUsage";
import { useTranslation } from "react-i18next";

const initialState = {
  nom: "",
};

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;
  const [state, setState] = useState(initialState);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const recupData = async () => {
    const res = await apiGetUsage(ReduxInstance._id, id);
    setState(res.data);
  };

  const submitData = async () => {
    if (id) {
      await apiUpdateUsage(id, state);
      handleRecupDatas();
    } else {
      await apiSaveUsage(ReduxInstance._id, state);
      handleRecupDatas();
    }
    handleClose();
  };

  useEffect(() => {
    if (id) recupData();
    else setState(initialState);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t("admin.PageAdminUsages.modalCreateEditTitre2")
            : t("admin.PageAdminUsages.modalCreateEditTitre1")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            placeholder={t("commun.form.placeholder.placeholder1")}
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
